import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { Author } from './components/Author';
import { WhoThisIsFor } from './components/WhoThisIsFor';
import { HowItWorks } from './components/HowItWorks';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || window.fbq) return;
    (function (f: any, b: Document, e: string, v: string) {
      let n: any, t: HTMLScriptElement, s: HTMLScriptElement | null;
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
      s?.parentNode?.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1011216287940548');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-navy selection:bg-electric/30 selection:text-white" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1011216287940548&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <Hero data-id="element-3" />
      <OpeningHook data-id="element-4" />
      <Problem data-id="element-5" />
      <UniqueMechanism data-id="element-6" />
      <WhatYouGet data-id="element-7" />
      <Author data-id="element-8" />
      <WhoThisIsFor data-id="element-9" />
      <HowItWorks data-id="element-10" />
      <FAQ data-id="element-11" />
      <Guarantee data-id="element-12" />
      <Testimonials data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </main>;
}